//Javascript for the WECAN Employer Remembered Candidate functionality
app.RememberedCandidates = (
    function () {
        var rememberedCandidates = {
            //Index Page
            Index: function () {
                $(document).on("click", '[data-role="employer-save-candidate"]', function () {
                    var forgetCandidate = true;

                    //text and button updates
                    if ($(this).hasClass('btn')) {
                        if ($(this).hasClass("btn-secondary")) {
                            //clicking to re-add candidate as remembered
                            $(this).removeClass("btn-secondary");
                            $(this).addClass("btn-primary");
                            $(this).text("Forget Candidate");
                            forgetCandidate = false;
                        }
                        else {
                            $(this).addClass("btn-secondary");
                            $(this).removeClass("btn-primary");
                            $(this).text("Undo");
                        }
                    }
                    else {
                        if ($(this).find('i').hasClass("fa-star-o")) {
                            //clicking to re-add candidate as remembered
                            $(this).find('i').removeClass("fa-star-o");
                            $(this).find('i').addClass("fa-star");
                            forgetCandidate = false;
                        }
                        else {
                            $(this).find('i').addClass("fa-star-o");
                            $(this).find('i').removeClass("fa-star");
                        }
                    }

                    //get row id which is application id
                    var id = $(this).closest('tr').find('input[type="hidden"]').val();
                    var url = forgetCandidate ? $(this).data('unsave-url') : $(this).data('save-url')
                    //ajax to update db
                    $.ajax({
                        type: "POST",
                        data: { Id: id },
                        url: url,
                        success: function (data) {
                            if (data) { //close modal
                                if (forgetCandidate) {
                                    toastr.success("The candidate has been removed from your remembered list.");
                                }
                                else {
                                    toastr.success("The candidate has been re-added to your remembered list.");
                                }
                            }
                            else {
                                toastr.error("Something went wrong. Please try again.");
                            }
                        },
                        error: function () {
                            toastr.error("Something went wrong. Please try again.");
                        }
                    });
                });
            },
            CandidateInfo: function () {
                $(document).on('click', '[data-open-all-accordions]', function () {
                    $('.collapse', $(this).closest('[data-role="applicant-history-container"]')).collapse('show');
                });
            }
        };
        return rememberedCandidates;
    }()
);